import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
import { Link, useNavigate, useParams } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFlag, faPenToSquare,  faCheck, faX  } from "@fortawesome/free-solid-svg-icons"
import { useGetUpdatedResponsesQuery } from "../responses/responsesApiSlice"
import getFilePath from "../../utils/getFilePath"
import { useEffect, useState } from "react"
const GradesUpdatedList = () => {
    const {groupId, taskId, type} = useParams()
    const [codeSearch, setCodeSearch] = useState("")
    const [userFilter, setUserFilter] = useState("")
    const [full, setFull] = useState(0);

    const navigate = useNavigate() 
    useTitle('geshtop-Exercise: Grades List')
    const {
        data: responses,
        isLoading,
        isSuccess,
        isError,
        error,
        refetch
    } = useGetUpdatedResponsesQuery({full})

    let content

    if (isLoading ) content = <PulseLoader color={"#FFF"} />

    if (isError) {
        content = <p className="errmsg">{error?.data?.message}</p>
    }
    const handleShow = (taskId,responseId) =>  navigate(`/${type}/${groupId}/grades/task/${taskId}/${responseId}`)
    if (isSuccess  ) {
       
        
        const temResponse = responses.map(response=>{
            const newResponse = {...response}
            newResponse.responseCombinedText = JSON.stringify(response.body || "").toLowerCase() + JSON.stringify(response.additions||"").toLowerCase()
            return newResponse
        })
        const filterResponse =temResponse.filter(response=>{
            return (
                (groupId==='0' || response.group?._id === groupId) &&
                (codeSearch==='' || response.responseCombinedText.indexOf(codeSearch) > -1) &&
                (userFilter==='' || (response.fullname.indexOf(userFilter) > -1|| response.username.indexOf(userFilter) > -1))
            )
        })
        
        //groupId!=='0'? responses.filter(res=>res.group===groupId) : [...responses]
        const tableContent = filterResponse.map((response, key) => {
            const grade = response.grade || -1;
            return(
            <tr className="table__row" key={`table-action-${key}`} >
                <td className="table__cell response__text"> {key}. {response.updated &&<FontAwesomeIcon icon={faFlag} />} {response.username}</td>
                <td className="table__cell response__text"><span className="d-flex">
                    {response.fullname}
                    {response.userImage && <div className='profile-image' style={{backgroundImage:`url(${getFilePath(response.userImage)})`}}></div>}
                    </span>
                    </td>
                    <td className="table__cell response__text">
                        {response.group?.name} |  {response.group?.year}
                    </td>
                <td className="table__cell response__text"> <Link style={{color:"Black"}} target="_blank" to={`/${type}/${groupId}/grades/task/${response.task._id}`}> {response.task.title} </Link></td>
                <td className="table__cell response__text">{response.comments}</td>
                {/* <td className="table__cell response__text">{response.responseAt}</td> */}

                <td className="table__cell action__status">
                    {grade > -1
                    ? <span className="status--completed">{grade}</span>
                    : <span className="status--open">לא ניתן ציון</span>
                    } 
                </td>
                {/* <td className="table__cell response__text">{response.gradeBy}</td> */}

                <td className="table__cell">
                   { <button
                        className="icon-button table__button"
                        onClick={()=>handleShow(0,response._id)}
                    >
                        <FontAwesomeIcon icon={faPenToSquare} />
                    </button> }
               
                  
                </td>
            </tr>
            )
        }
        
        
            )

        content = (
            <>
           <div className="filter-form">
           <h2>תרגילים לבדיקה</h2>
<button
  onClick={() => setFull(full ? 0 : 1)}
  className={`
    px-4 py-2 
    rounded-xl 
    text-white 
    text-sm 
    font-medium 
    shadow 
    transition 
    active:scale-95
    ${full 
      ? 'bg-green-600 hover:bg-green-700'   // FULL פעיל → ירוק
      : 'bg-indigo-600 hover:bg-indigo-700' // FULL לא פעיל → אינדיגו
    }
  `}
>
      <FontAwesomeIcon icon={full ? faCheck : faX} /> &nbsp;
  שליפת שדות לחיפוש טקסטואלי
  
</button>
{full >0&&
           <div className="filter-form-item">
                <input  placeholder="חיפוש פנימי לפי ביצוע" className="form__input sm" onChange={(e)=>setCodeSearch(e.target.value)} />
            </div>}
           <div className="filter-form-item">
                <input placeholder="חיפוש פנימי לפי משתמש" className="form__input sm" onChange={(e)=>setUserFilter(e.target.value)} />
            </div>
            </div>
            <table className="table table--admin-grades">
                <thead className="table__thead">
                    <tr>
                        <th scope="col" className="table__th admin-grades--user__username">Username</th>
                        <th scope="col" className="table__th admin-grades--user__name">שם</th>
                        <th scope="col" className="table__th admin-grades--user__name">קבוצה</th>
                        <th scope="col" className="table__th admin-grades--user__name">משימה</th>
                        <th scope="col" className="table__th admin-grades--user__email">הערות</th>
                        {/* <th scope="col" className="table__th user__phone">הוגש בתאריך</th> */}
                        <th scope="col" className="table__th admin-grades--user__groups">ציון</th>                      
                        {/* <th scope="col" className="table__th user__roles">ע"י</th> */}
                        <th scope="col" className="table__th admin-grades--user__edit">#</th>
                    </tr>
                </thead>
                <tbody>
                    {tableContent }
                </tbody>
            </table>
            </>
        )
    }

    return content
}
export default GradesUpdatedList